import "./index.css";

import img from "../../../Images/trump.jpg"
function ReadBlog() {

    return (
        <div className="readBlog">
            <div className="firstColumn">
                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                <h2>She was quite silent for a minute or two</h2>
                <img src={img}></img>
                <p className="pText">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div>
            <div className="secondColumn">
                    <ul>
                        <li>
                            <img src={img}></img>
                            <div>
                                <h4>Idly digging his toes in the sand</h4>
                                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                                <div class="text">Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır.
                                </div>
                            </div>
                        </li>
                        <li>
                            <img src={img}></img>
                            <div>
                                <h4>Idly digging his toes in the sand</h4>
                                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                                <div class="text">Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır.
                                </div>
                            </div>
                        </li>
                        <li>
                            <img src={img}></img>
                            <div>
                                <h4>Idly digging his toes in the sand</h4>
                                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                                <div class="text">Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır.
                                </div>
                            </div>
                        </li>
                        <li>
                            <img src={img}></img>
                            <div>
                                <h4>Idly digging his toes in the sand</h4>
                                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                                <div class="text">Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır.
                                </div>
                            </div>
                        </li>
                        <li>
                            <img src={img}></img>
                            <div>
                                <h4>Idly digging his toes in the sand</h4>
                                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                                <div class="text">Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır.
                                </div>
                            </div>
                        </li>
                        <li>
                            <img src={img}></img>
                            <div>
                                <h4>Idly digging his toes in the sand</h4>
                                <p><span>Davronbek</span> * <span>August 17, 2025</span></p>
                                <div class="text">Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır.
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            
        </div>
        );
}

export default ReadBlog;
